// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_infoText__container__Quq35 {
  background-color: rgba(24, 49, 110, 0.3);
  width: 100%;
  padding: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.styles_msgs__container__ig6sx {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  height: 267px;
}

.styles_msgModule__container__yw1UX {
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  min-height: 2.5rem;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  max-width: 35rem;
  padding: 5px;
  gap: 5px;
}

.styles_right__CwOlM {
  flex-direction: row-reverse;
}

.styles_dateText__moduleMsg__zkgsJ {
  text-align: left;
  font-size: 12px;
  font-weight: 300;
}

.styles_dateText__moduleMsg_rigth__TLcJF {
  text-align: end;
}

.styles_main__container__3Iwrr {
  display: flex;
  gap: 0.5rem;
}

.styles_topic__module__MbVmG {
  background-color: #fff;
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 50%;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .styles_msgs__container__ig6sx {
    height: 220px;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatAssincrono/UiChat/styles.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE;IACE,aAAa;EACf;;AAEF","sourcesContent":[".infoText__container {\n  background-color: rgba(24, 49, 110, 0.3);\n  width: 100%;\n  padding: 0.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n.msgs__container {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  overflow-y: auto;\n  height: 267px;\n}\n\n.msgModule__container {\n  align-self: flex-start;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  min-height: 2.5rem;\n  border-radius: 8px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\n  max-width: 35rem;\n  padding: 5px;\n  gap: 5px;\n}\n\n.right {\n  flex-direction: row-reverse;\n}\n\n.dateText__moduleMsg {\n  text-align: left;\n  font-size: 12px;\n  font-weight: 300;\n}\n\n.dateText__moduleMsg_rigth {\n  text-align: end;\n}\n\n.main__container {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.topic__module {\n  background-color: #fff;\n  width: 0.9rem;\n  height: 0.9rem;\n  border-radius: 50%;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\n}\n\n@media (max-width: 768px) {\n  .msgs__container {\n    height: 220px;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoText__container": `styles_infoText__container__Quq35`,
	"msgs__container": `styles_msgs__container__ig6sx`,
	"msgModule__container": `styles_msgModule__container__yw1UX`,
	"right": `styles_right__CwOlM`,
	"dateText__moduleMsg": `styles_dateText__moduleMsg__zkgsJ`,
	"dateText__moduleMsg_rigth": `styles_dateText__moduleMsg_rigth__TLcJF`,
	"main__container": `styles_main__container__3Iwrr`,
	"topic__module": `styles_topic__module__MbVmG`
};
export default ___CSS_LOADER_EXPORT___;
